import styled from 'styled-components';
import colors from '_colors.module.scss';
import { BdsIcon, BdsInput, BdsTableRow } from 'blip-ds/dist/blip-ds-react';

export const SearchInput = styled(BdsInput)`
  width: 18.75rem;
`;

export const MoreOptionsButton = styled(BdsIcon)`
  cursor: pointer;
`;

export const CatalogUpdatedBy = styled.div`
  bds-typo {
    color: ${colors.ContentGhost};
  }
`;

export const StyledTableRow = styled(BdsTableRow)<{ isActive: boolean }>`
  background-color: ${({ isActive }) => (isActive ? colors.Surface1 : 'transparent')};
  transition: all 0.2s ease-in-out;
`;
